import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "FirstVideo",
    component: () => import("../components/FirstVideo.vue"),
  },
  {
    path: "/navPage",
    name: "navPage",
    component: () => import("../components/NavPage.vue"),
  },
  {
    path: "/contentsprite/:id",
    name: "contentsprite",
    component: () => import("../components/ContentSprite.vue"),
  },
  {
    path: "/redian",
    name: "redian",
    component: () => import("../components/redian.vue"),
  }
];

const router = new VueRouter({
  routes,
});
// router.beforeEach((to,from,next)=>{
//   console.log(to,from);
//   if(to.path == "/navPage"&& from.path == "/"){
//     next("/")
//   }else
//   next()
// })
export default router;
